import { render, staticRenderFns } from "./CotizacionesMetricas.vue?vue&type=template&id=5b2fd45d&"
import script from "./CotizacionesMetricas.vue?vue&type=script&lang=js&"
export * from "./CotizacionesMetricas.vue?vue&type=script&lang=js&"
import style0 from "./CotizacionesMetricas.vue?vue&type=style&index=0&id=5b2fd45d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports